(function () {
  'use strict';
  const resolveAsset = path => window.mvpChurchAssetUrls?.[path] || path;
  const resolveSrcset = value => String(value || '').split(',').map(entry => {
    const parts = entry.trim().split(/\s+/);
    return [resolveAsset(parts[0]), ...parts.slice(1)].join(' ');
  }).join(', ');
  const polePlanner = document.querySelector('[data-pole-planner]');
  if (polePlanner) {
    let records = [];
    try { records = JSON.parse(polePlanner.querySelector('[data-pole-planner-data]')?.textContent || '[]'); } catch {}
    if (records.length) {
      const money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
      const renderPolePlan = (announce = false) => {
        const finish = polePlanner.querySelector('[name="pole-mount"]:checked')?.value || 'pocket';
        const size = polePlanner.querySelector('[name="pole-banner-size"]:checked')?.value || '18x36';
        const input = polePlanner.querySelector('[name="pole-locations"]');
        const locations = Math.max(1, Math.min(99, Math.round(Number(input.value) || 1)));
        input.value = locations;
        const perLocation = Number(polePlanner.querySelector('[name="pole-faces"]:checked')?.value || 1);
        const quantity = locations * perLocation;
        const record = records.find(item => item.size === size && item.finish === finish);
        const dimensions = records.find(item => item.size === size);
        if (!dimensions) return;

        const stage = polePlanner.querySelector('.pole-banner-stage');
        const shapes = polePlanner.querySelectorAll('[data-pole-banner-shape]');
        const catalogWidth = Math.max(...records.map(item => item.width));
        const catalogHeight = Math.max(...records.map(item => item.height));
        const availableHeight = Math.max(120, Math.min(360, stage.clientHeight - 121));
        const availableHalfWidth = Math.max(80, stage.clientWidth / 2 - 18);
        const scale = Math.min(availableHeight / catalogHeight, availableHalfWidth / catalogWidth);
        const bannerWidth = `${Math.round(dimensions.width * scale)}px`;
        const bannerHeight = `${Math.round(dimensions.height * scale)}px`;
        stage.style.setProperty('--pole-banner-width', bannerWidth);
        stage.style.setProperty('--pole-banner-height', bannerHeight);
        shapes.forEach(shape => {
          shape.style.setProperty('--pole-banner-width', bannerWidth);
          shape.style.setProperty('--pole-banner-height', bannerHeight);
        });
        polePlanner.querySelectorAll('[data-pole-second]').forEach(element => { element.hidden = perLocation === 1; });
        polePlanner.querySelector('[data-pole-visual-width]').textContent = `${dimensions.width} in wide`;
        polePlanner.querySelector('[data-pole-visual-height]').textContent = `${dimensions.height} in tall`;
        polePlanner.querySelector('[data-pole-visual-size]').textContent = dimensions.label;
        polePlanner.querySelector('[data-pole-visual-count]').textContent = `${perLocation === 1 ? 'One banner' : 'Two banners'} shown at each location`;
        polePlanner.querySelector('[data-pole-result-title]').textContent = `${dimensions.label} pole banner`;
        polePlanner.querySelector('[data-pole-quantity]').textContent = quantity;
        const quantityLabel = polePlanner.querySelector('[data-pole-quantity]').nextSibling;
        if (quantityLabel) quantityLabel.textContent = quantity === 1 ? ' banner' : ' banners';

        if (!record) return;
        polePlanner.querySelector('[data-pole-finish]').textContent = record.finish_label;
        polePlanner.querySelector('[data-pole-price]').textContent = record.price;
        polePlanner.querySelector('[data-pole-subtotal]').textContent = money(Number(record.price.replace(/[$,]/g, '')) * quantity);
        const shop = polePlanner.querySelector('[data-pole-shop]');
        shop.href = record.url;
        const quote = polePlanner.querySelector('[data-pole-quote]');
        quote.dataset.quoteVariant = record.id;
        quote.dataset.quoteQuantity = quantity;
        if (announce) polePlanner.querySelector('[data-pole-status]').textContent = `${dimensions.label}, ${record.finish_label}, ${quantity} ${quantity === 1 ? 'banner' : 'banners'}. ${record.price} each; ${money(Number(record.price.replace(/[$,]/g, '')) * quantity)} print subtotal.`;
      };
      polePlanner.addEventListener('change', () => renderPolePlan(true));
      polePlanner.querySelector('[name="pole-locations"]')?.addEventListener('input', () => renderPolePlan(true));
      let poleResizeFrame;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(poleResizeFrame);
        poleResizeFrame = requestAnimationFrame(() => renderPolePlan());
      });
      renderPolePlan();
    }
  }
  const tentTool = document.querySelector('[data-tent-size-tool]');
  if (tentTool) {
    const sizeData = tentTool.querySelector('[data-tent-size-data]');
    let records = [];
    try { records = JSON.parse(sizeData?.textContent || '[]'); } catch {}
    if (records.length) {
      const controls = tentTool.querySelector('[data-tent-size-controls]');
      const table = tentTool.querySelector('[data-tent-size-table]');
      const scale = 10;
      const originX = 40;
      const originBottom = 245;
      const updateLink = (selector, record, type) => {
        const link = tentTool.querySelector(selector);
        link.href = record[`${type}_url`];
        link.dataset.product = record.key;
        if (selector.includes('quote')) link.dataset.quoteVariant = record[`${type}_variant`];
      };
      const renderTentSize = (key, announce = false) => {
        const record = records.find(item => item.key === key);
        if (!record) return;
        const width = record.width * scale;
        const depth = record.depth * scale;
        const x = originX;
        const y = originBottom - depth;
        const widthEnd = originX + width;
        const depthLineX = Math.min(254, widthEnd + 13);
        const depthTextX = Math.min(278, widthEnd + 35);
        const depthMidY = y + depth / 2;
        const rect = tentTool.querySelector('[data-tent-footprint-rect]');
        rect.setAttribute('x', x);
        rect.setAttribute('y', y);
        rect.setAttribute('width', width);
        rect.setAttribute('height', depth);
        const widthLine = tentTool.querySelector('[data-tent-footprint-width-line]');
        widthLine.setAttribute('x2', widthEnd);
        const widthEndTick = tentTool.querySelector('[data-tent-footprint-width-end]');
        widthEndTick.setAttribute('x1', widthEnd);
        widthEndTick.setAttribute('x2', widthEnd);
        const widthLabel = tentTool.querySelector('[data-tent-footprint-width]');
        widthLabel.setAttribute('x', originX + width / 2);
        widthLabel.textContent = `${record.width} ft wide`;
        const depthLine = tentTool.querySelector('[data-tent-footprint-depth-line]');
        depthLine.setAttribute('x1', depthLineX);
        depthLine.setAttribute('x2', depthLineX);
        depthLine.setAttribute('y1', y);
        const depthStartTick = tentTool.querySelector('[data-tent-footprint-depth-start]');
        depthStartTick.setAttribute('x1', depthLineX - 6);
        depthStartTick.setAttribute('x2', depthLineX + 6);
        depthStartTick.setAttribute('y1', y);
        depthStartTick.setAttribute('y2', y);
        const depthEndTick = tentTool.querySelector('[data-tent-footprint-depth-end]');
        depthEndTick.setAttribute('x1', depthLineX - 6);
        depthEndTick.setAttribute('x2', depthLineX + 6);
        const depthLabel = tentTool.querySelector('[data-tent-footprint-depth]');
        depthLabel.setAttribute('x', depthTextX);
        depthLabel.setAttribute('y', depthMidY);
        depthLabel.setAttribute('transform', `rotate(90 ${depthTextX} ${depthMidY})`);
        depthLabel.textContent = `${record.depth} ft deep`;
        const title = `${record.label} tent footprint, ${record.area} square feet.`;
        tentTool.querySelector('[data-tent-footprint-title]').textContent = title;
        tentTool.querySelector('[data-tent-footprint-svg]').setAttribute('aria-label', title);
        tentTool.querySelectorAll('[data-tent-size-area]').forEach(el => { el.textContent = record.area; });
        tentTool.querySelector('[data-tent-size-name]').textContent = record.label;
        tentTool.querySelector('[data-tent-size-heading]').textContent = `${record.label} canopy`;
        tentTool.querySelector('[data-tent-size-footprint]').textContent = record.label;
        tentTool.querySelector('[data-tent-size-frame]').textContent = `${record.frame_mm} mm hex aluminum`;
        tentTool.querySelector('[data-tent-kit-price]').textContent = record.kit_price;
        tentTool.querySelector('[data-tent-top-price]').textContent = record.top_price;
        updateLink('[data-tent-kit-shop]', record, 'kit');
        updateLink('[data-tent-kit-quote]', record, 'kit');
        updateLink('[data-tent-top-shop]', record, 'top');
        updateLink('[data-tent-top-quote]', record, 'top');
        if (announce) tentTool.querySelector('[data-tent-size-status]').textContent = `${record.label} selected. It covers ${record.area} square feet and uses a ${record.frame_mm} millimeter frame. Complete tent ${record.kit_price}; replacement top ${record.top_price}.`;
        try { sessionStorage.setItem('mvp-church-tent-size-v1', record.key); } catch {}
      };
      let initial = 'tent';
      try {
        const saved = sessionStorage.getItem('mvp-church-tent-size-v1');
        if (records.some(record => record.key === saved)) initial = saved;
      } catch {}
      const initialControl = controls.querySelector(`[name="tent-size"][value="${initial}"]`);
      if (initialControl) initialControl.checked = true;
      controls.addEventListener('change', event => {
        if (event.target.matches('[name="tent-size"]')) renderTentSize(event.target.value, true);
      });
      controls.hidden = false;
      table.open = false;
      renderTentSize(initial);
    }
  }
  const wallSelector = document.querySelector('[data-wall-selector]');
  if (wallSelector) {
    const standardWallUrl = 'https://mvpvisuals.com/products/custom-canopy-tent-walls';
    const meshWallUrl = 'https://mvpvisuals.com/products/custom-canopy-tent-mesh-walls';
    const states = {
      open: {
        kicker: 'Open-sided canopy', title: 'Open tent, no walls',
        copy: 'With no walls, guests can walk in from any direction.',
        coverage: 'No walls', order: 'With the matching canopy tent',
        action: 'Choose a tent size ↑', url: '#tent-sizes',
        note: 'Your order will include the tent only.', image: 'tent-open-side-product', imageMax: 1080,
        imageAlt: '10 by 10 foot custom canopy tent with all four sides open',
        imageCaption: 'Open 10 × 10 canopy and frame. Walls are optional.'
      },
      half: {
        kicker: 'Printed half walls', title: 'Create a welcoming counter',
        copy: 'Half walls give your team a natural place to greet guests or hand out materials without closing off the tent.',
        coverage: 'Two half walls', order: 'With the matching canopy tent',
        action: 'Configure half walls ↗', url: '',
        note: 'Choose single- or double-sided printing on the matching canopy product page.', image: 'tent-half-walls-product', imageMax: 1080,
        imageAlt: '10 by 10 foot custom canopy tent with a pair of printed half walls',
        imageCaption: 'Two half walls on a 10 × 10 tent. Select them with the matching canopy.'
      },
      solid: {
        kicker: 'Solid printed tent wall', title: 'Create a branded back wall',
        copy: 'One wall creates a printed backdrop. Add individually ordered walls when you need more sides covered.',
        coverage: 'One full wall per quantity', order: 'On the tent wall product page',
        action: 'Shop solid walls ↗', url: standardWallUrl,
        note: 'Single- and double-sided printing are available. Canopy and frame are not included.', image: 'tent-full-wall-product', imageMax: 1600,
        imageAlt: '10 by 10 foot custom canopy tent with one solid full-height wall and a person for scale',
        imageCaption: 'One full wall on a 10 × 10 tent. Order each wall separately.'
      },
      door: {
        kicker: 'Tent wall with door', title: 'Give the enclosed tent an entrance',
        copy: 'A door wall makes it clear where guests and staff should enter.',
        coverage: 'One full wall with door', order: 'On the tent wall product page',
        action: 'Shop door walls ↗', url: standardWallUrl,
        note: 'Single- and double-sided printing are available. Canopy and frame are not included.', image: 'tent-wall-door-product', imageMax: 1600,
        imageAlt: '10 by 10 foot custom canopy tent with one full-height wall containing a door',
        imageCaption: 'Door wall on a 10 × 10 tent. The wall does not include a canopy or frame.'
      },
      pvc: {
        kicker: 'Clear-window tent wall', title: 'Keep the booth visible',
        copy: 'Choose one or two clear PVC windows when you want a full wall without blocking the view through it.',
        coverage: 'Full wall with one or two PVC windows', order: 'On the tent wall product page',
        action: 'Shop PVC-window walls ↗', url: standardWallUrl,
        note: 'A door-and-window style is also available. Canopy and frame are not included.', image: 'tent-wall-pvc-product', imageMax: 1600,
        imageAlt: '10 by 10 foot custom canopy tent with one full-height wall containing a clear PVC window',
        imageCaption: 'One PVC window on a 10 × 10 tent. One- and two-window styles are available.'
      },
      mesh: {
        kicker: 'Mesh-window tent wall', title: 'Add airflow through a full wall',
        copy: 'Choose one or two mesh or poly-mesh windows when you want wall coverage with more airflow.',
        coverage: 'Full wall with one or two mesh windows', order: 'On the mesh-wall product page',
        action: 'Shop mesh-window walls ↗', url: meshWallUrl,
        note: 'Single- and double-sided printing are available. Canopy and frame are not included.', image: 'tent-wall-mesh-product', imageMax: 1600,
        imageAlt: '10 by 10 foot custom canopy tent with one full-height wall containing two mesh windows',
        imageCaption: 'Two mesh windows on a 10 × 10 tent. Mesh and poly-mesh styles are available.'
      }
    };
    const selectedTentUrl = () => {
      const selected = tentTool?.querySelector('[name="tent-size"]:checked')?.value;
      let records = [];
      try { records = JSON.parse(tentTool?.querySelector('[data-tent-size-data]')?.textContent || '[]'); } catch {}
      const record = records.find(item => item.key === selected);
      return record ? record.kit_url.split('?')[0] : '#tent-sizes';
    };
    const renderWall = (announce = false) => {
      const coverage = wallSelector.querySelector('[name="wall-coverage"]:checked').value;
      const functionGroup = wallSelector.querySelector('[data-wall-functions]');
      functionGroup.hidden = coverage !== 'full';
      const functionValue = wallSelector.querySelector('[name="wall-function"]:checked').value;
      const key = coverage === 'full' ? functionValue : coverage;
      const state = states[key];
      const result = wallSelector.querySelector('[data-wall-result]');
      result.classList.add('is-changing');
      wallSelector.querySelector('[data-wall-kicker]').textContent = state.kicker;
      wallSelector.querySelector('[data-wall-title]').textContent = state.title;
      wallSelector.querySelector('[data-wall-copy]').textContent = state.copy;
      wallSelector.querySelector('[data-wall-coverage-copy]').textContent = state.coverage;
      wallSelector.querySelector('[data-wall-order-copy]').textContent = state.order;
      wallSelector.querySelector('[data-wall-note]').textContent = state.note;
      const image = wallSelector.querySelector('[data-wall-image]');
      const imageBase = `assets/product-photography/optimized/${state.image}`;
      image.src = resolveAsset(`${imageBase}-${state.imageMax}.webp`);
      image.srcset = resolveSrcset(`${imageBase}-360.webp 360w, ${imageBase}-720.webp 720w, ${imageBase}-${state.imageMax}.webp ${state.imageMax}w`);
      image.alt = state.imageAlt;
      wallSelector.querySelector('[data-wall-image-caption]').textContent = state.imageCaption;
      const action = wallSelector.querySelector('[data-wall-action]');
      action.textContent = state.action;
      action.href = key === 'half' ? selectedTentUrl() : state.url;
      requestAnimationFrame(() => result.classList.remove('is-changing'));
      if (announce) wallSelector.querySelector('[data-wall-status]').textContent = `${state.title}. ${state.coverage}. ${state.note}`;
    };
    wallSelector.addEventListener('change', () => renderWall(true));
    tentTool?.querySelector('[data-tent-size-controls]')?.addEventListener('change', () => {
      if (wallSelector.querySelector('[name="wall-coverage"]:checked').value === 'half') renderWall();
    });
    renderWall();
  }
  const backdropFinder = document.querySelector('[data-backdrop-finder]');
  if (backdropFinder) {
    let model = { states: {}, refinements: {} };
    try { model = JSON.parse(backdropFinder.querySelector('[data-backdrop-finder-data]')?.textContent || '{}'); } catch {}
    const renderBackdrop = (announce = false) => {
      const width = backdropFinder.querySelector('[name="backdrop-width"]:checked')?.value || 'standard';
      const support = backdropFinder.querySelector('[name="backdrop-support"]:checked')?.value || 'need';
      const refinement = backdropFinder.querySelector('[name="backdrop-refinement"]:checked')?.value || 'first';
      const refinementGroup = backdropFinder.querySelector('[data-backdrop-refinement]');
      const refinementLabels = model.refinements?.[`${width}|${support}`];
      refinementGroup.hidden = !refinementLabels;
      if (refinementLabels) {
        backdropFinder.querySelector('[data-backdrop-refinement-label="first"]').textContent = refinementLabels[0];
        backdropFinder.querySelector('[data-backdrop-refinement-label="second"]').textContent = refinementLabels[1];
      }
      const key = `${width}|${support}|${refinementLabels ? refinement : 'first'}`;
      const state = model.states?.[key];
      if (!state) return;
      const result = backdropFinder.querySelector('[data-backdrop-result]');
      result.classList.add('is-changing');
      const image = backdropFinder.querySelector('[data-backdrop-image]');
      image.src = resolveAsset(state.image_src);
      image.srcset = resolveSrcset(state.image_srcset);
      image.alt = state.image_alt;
      image.width = state.image_width;
      image.height = state.image_height;
      backdropFinder.querySelector('[data-backdrop-image-badge]').textContent = state.image_badge;
      backdropFinder.querySelector('[data-backdrop-title]').textContent = state.title;
      backdropFinder.querySelector('[data-backdrop-copy]').textContent = state.copy;
      backdropFinder.querySelector('[data-backdrop-width-copy]').textContent = state.width;
      backdropFinder.querySelector('[data-backdrop-included]').textContent = state.included;
      backdropFinder.querySelector('[data-backdrop-price]').textContent = state.price;
      backdropFinder.querySelector('[data-backdrop-note]').textContent = state.note;
      const action = backdropFinder.querySelector('[data-backdrop-action]');
      action.href = state.url;
      action.dataset.product = state.product;
      requestAnimationFrame(() => result.classList.remove('is-changing'));
      if (announce) backdropFinder.querySelector('[data-backdrop-status]').textContent = `${state.title}. Starting at ${state.price}. ${state.included}.`;
    };
    backdropFinder.addEventListener('change', () => renderBackdrop(true));
    renderBackdrop();
  }
  const mountingFinder = document.querySelector('[data-mounting-finder]');
  if (mountingFinder) {
    let states = {};
    try { states = JSON.parse(mountingFinder.querySelector('[data-mounting-data]')?.textContent || '{}'); } catch {}
    const renderMounting = (announce = false) => {
      const support = mountingFinder.querySelector('[name="mounting-support"]:checked')?.value || 'hooks';
      const frame = mountingFinder.querySelector('[name="mounting-frame"]:checked')?.value || 'first';
      const frameGroup = mountingFinder.querySelector('[data-mounting-frame]');
      frameGroup.hidden = support !== 'frame';
      const state = states[`${support}|${support === 'frame' ? frame : 'first'}`];
      if (!state) return;
      const result = mountingFinder.querySelector('[data-mounting-result]');
      result.classList.add('is-changing');
      mountingFinder.querySelector('[data-mounting-kicker]').textContent = state.kicker;
      mountingFinder.querySelector('[data-mounting-title]').textContent = state.title;
      mountingFinder.querySelector('[data-mounting-copy]').textContent = state.copy;
      mountingFinder.querySelector('[data-mounting-finish]').textContent = state.finish;
      mountingFinder.querySelector('[data-mounting-measure]').textContent = state.measure;
      mountingFinder.querySelector('[data-mounting-note]').textContent = state.note;
      const image = mountingFinder.querySelector('[data-mounting-image]');
      image.src = resolveAsset(state.image_src);
      image.srcset = resolveSrcset(state.image_srcset);
      image.alt = state.image_alt;
      image.width = state.image_width;
      image.height = state.image_height;
      const action = mountingFinder.querySelector('[data-mounting-action]');
      action.textContent = state.action;
      action.href = state.url;
      action.dataset.product = state.product;
      if (state.url.startsWith('#')) action.removeAttribute('data-track');
      else action.dataset.track = 'church_product_click';
      requestAnimationFrame(() => result.classList.remove('is-changing'));
      if (announce) mountingFinder.querySelector('[data-mounting-status]').textContent = `${state.title}. ${state.finish}. ${state.note}`;
    };
    mountingFinder.addEventListener('change', () => renderMounting(true));
    renderMounting();
  }
  const comparison = document.querySelector('[data-flag-configurator]');
  if (!comparison) return;
  const variants = window.mvpChurchVariants;
  const keys = ['flag', 'teardrop', 'rectangle'];
  const selectionKey = 'mvp-church-flag-selection-v1';
  const fit = document.querySelector('[data-rectangle-fit]');
  const fitStates = {
    '10': { name: 'Small', graphic: 6.6, image: 'rectangle-flag-10ft-human-scale', alt: '10 foot rectangle flag with cross base shown beside a person for scale' },
    '14': { name: 'Medium', graphic: 8.2, image: 'rectangle-flag-14ft-human-scale', alt: '14 foot rectangle flag with cross base shown beside a person for scale' },
    '17': { name: 'Large', graphic: 9.8, image: 'rectangle-flag-17ft-human-scale', alt: '17 foot rectangle flag with cross base shown beside a person for scale' }
  };
  const visibilityDistance = fit?.querySelector('[data-visibility-distance]');
  const defaultDistanceForSize = { '10': 50, '14': 100, '17': 200 };
  const apparentAngle = (graphicHeight, distance) => Math.atan(graphicHeight / distance) * 180 / Math.PI;
  const recommendForDistance = distance => distance <= 60 ? '10' : distance <= 140 ? '14' : '17';
  const renderFit = (height, announce = false) => {
    if (!fit || !fitStates[height]) return;
    const state = fitStates[height];
    const distance = Number(visibilityDistance?.value || 100);
    const recommended = recommendForDistance(distance);
    const angle = apparentAngle(state.graphic, distance);
    fit.querySelector(`[name=rectangle-fit-size][value="${height}"]`).checked = true;
    fit.classList.add('is-resizing');
    const image = fit.querySelector('[data-visibility-image]');
    const imageBase = `assets/product-photography/optimized/${state.image}`;
    image.src = resolveAsset(`${imageBase}-720.webp`);
    image.srcset = resolveSrcset(`${imageBase}-360.webp 360w, ${imageBase}-720.webp 720w, ${imageBase}-1080.webp 1080w`);
    image.alt = state.alt;
    fit.querySelector('[data-fit-name]').textContent = state.name + ' rectangle flag';
    fit.querySelector('[data-fit-summary]').textContent = `${height} ft assembled · 2.6 × ${state.graphic} ft printed graphic`;
    fit.querySelector('[data-distance-output]').textContent = `${distance} ft`;
    const tier = distance <= 60 ? 'Near an entrance' : distance <= 140 ? 'Across the parking lot' : 'From the roadside';
    const copy = recommended === '10'
      ? 'The 10 ft flag works well near an entrance or along a short approach.'
      : recommended === '14'
        ? 'The 14 ft flag is easier to spot across an open parking lot.'
        : 'The 17 ft flag gives your artwork the most room for a longer roadside approach.';
    const guidance = distance <= 60 ? 'A logo and one short message' : distance <= 140 ? 'A large logo or 2–4 large words' : 'One symbol and 1–3 large words';
    const presence = angle >= 4 ? 'Easy to spot' : angle >= 2.5 ? 'Easy to see' : 'Easy to miss at this distance';
    fit.querySelector('[data-visibility-tier]').textContent = tier;
    fit.querySelector('[data-visibility-title]').textContent = `${recommended} ft recommended`;
    fit.querySelector('[data-visibility-copy]').textContent = copy;
    fit.querySelector('[data-selected-presence]').textContent = `${height} ft · ${angle.toFixed(1)}° view angle · ${presence}`;
    fit.querySelector('[data-message-guidance]').textContent = guidance;
    const useRecommended = fit.querySelector('[data-use-recommended]');
    useRecommended.textContent = height === recommended ? `${recommended} ft selected` : `Use recommended ${recommended} ft`;
    useRecommended.disabled = height === recommended;
    if (announce) fit.querySelector('[data-visibility-status]').textContent = `${tier}. ${recommended} foot flag recommended. The selected ${height} foot flag is ${presence.toLowerCase()}.`;
    requestAnimationFrame(() => fit.classList.remove('is-resizing'));
  };
  try {
    const saved = JSON.parse(sessionStorage.getItem(selectionKey));
    if (saved) {
      for (const [name,values] of [['printing',['single','double']],['base',['stake','cross']]]) if (values.includes(saved[name])) comparison.querySelector(`[name=flag-${name}][value=${saved[name]}]`).checked = true;
      for (const key of keys) { const select = document.querySelector(`[data-flag-height="${key}"]`);if ([...select.options].some(o=>o.value===saved.heights?.[key])) select.value = saved.heights[key]; }
    }
  } catch {}
  if (!variants || !keys.every(key => variants[key]?.length)) return;
  const money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(value);
  const compactRange = values => {
    const usable = values.filter(value => value !== null);
    if (!usable.length) return '(unavailable)';
    const compactSigned = value => value === 0 ? '$0' : `${value > 0 ? '+' : '−'}${money(Math.abs(value))}`;
    const low = Math.min(...usable), high = Math.max(...usable);
    return low === high ? `(${compactSigned(low)})` : `(${compactSigned(low)} to ${compactSigned(high)})`;
  };
  const description = v => `${v.height} ft, ${v.printing === 'double' ? 'double-sided' : 'single-sided'}, ${v.base === 'cross' ? 'cross base with water bag' : 'ground stake'}`;
  const setLink = (link, record) => {
    if (record?.available) {
      link.href = record.url;
      link.removeAttribute('aria-disabled');
      link.removeAttribute('tabindex');
    } else {
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
    }
  };
  const render = (announce = false) => {
    const printing = comparison.querySelector('[name=flag-printing]:checked').value;
    const base = comparison.querySelector('[name=flag-base]:checked').value;
    const summaries = [];
    for (const key of keys) {
      const card = document.querySelector('#product-' + key);
      const height = card.querySelector('[data-flag-height]').value;
      const record = variants[key].find(v => v.height === height && v.printing === printing && v.base === base);
      card.querySelector('[data-card-price]').textContent = record?.available ? money(record.price) : 'Unavailable';
      card.querySelector('[data-card-configuration]').textContent = record ? description(record) : 'Unavailable with these options.';
      card.querySelectorAll('[data-track=church_product_click]').forEach(link => setLink(link, record));
      const quote = card.querySelector('[data-quote-products]');
      if (record?.available) {
        quote.dataset.quoteVariant = record.id;
        quote.removeAttribute('aria-disabled');
      } else {
        delete quote.dataset.quoteVariant;
        quote.setAttribute('aria-disabled', 'true');
      }
      document.querySelectorAll(`[data-flag-order="${key}"]`).forEach(link => setLink(link, record));
      document.querySelectorAll(`[data-flag-selected-height="${key}"]`).forEach(el => { el.textContent = height + ' ft'; });
      for (const otherBase of ['stake', 'cross']) {
        const other = variants[key].find(v => v.height === height && v.printing === printing && v.base === otherBase);
        document.querySelectorAll(`[data-flag-price="${key}"][data-base="${otherBase}"]`).forEach(link => {
          link.textContent = other?.available ? money(other.price) + ' ↗' : 'Unavailable';
          setLink(link, other);
        });
        document.querySelectorAll(`[data-flag-quote="${key}"][data-base="${otherBase}"]`).forEach(link => {
          if(other?.available){link.dataset.quoteVariant=other.id;link.removeAttribute('aria-disabled');}
          else{delete link.dataset.quoteVariant;link.setAttribute('aria-disabled','true');}
        });
      }
      summaries.push(`${window.mvpChurchCatalog[key].name}: ${record?.available ? description(record) + ', ' + money(record.price) : 'unavailable'}`);
    }
    document.querySelectorAll('[data-flag-print-label]').forEach(el => { el.textContent = printing === 'double' ? 'Double-sided' : 'Single-sided'; });
    const selectedHeights = Object.fromEntries(keys.map(key => [key, document.querySelector(`[data-flag-height="${key}"]`).value]));
    renderFit(selectedHeights.rectangle);
    const deltaFor = (key, fromPrinting, fromBase, toPrinting, toBase) => {
      const height = selectedHeights[key];
      const from = variants[key].find(v => v.height === height && v.printing === fromPrinting && v.base === fromBase);
      const to = variants[key].find(v => v.height === height && v.printing === toPrinting && v.base === toBase);
      return from?.available && to?.available ? to.price - from.price : null;
    };
    comparison.querySelector('[data-print-surcharge]').textContent = compactRange(keys.map(key => deltaFor(key,'single',base,'double',base)));
    comparison.querySelector('[data-base-surcharge]').textContent = compactRange(keys.map(key => deltaFor(key,printing,'stake',printing,'cross')));
    comparison.querySelector('[data-print-advice]').textContent = printing === 'double'
      ? 'Wording reads correctly on both faces. Check directional arrows against each approach before approving the proof.'
      : 'Artwork shows through in reverse on the back. Choose double-sided when visitors need to read the wording from both directions.';
    comparison.querySelector('[data-base-advice]').textContent = base === 'cross'
      ? 'For pavement or indoor floors. The price includes the cross base and water bag. Indoors, make sure the flag clears the ceiling.'
      : 'For grass, sand or soil where you can use a stake. The price includes the ground stake.';
    const templateList = document.querySelector('[data-selected-template-links]');
    if (templateList && window.mvpChurchTemplates) {
      templateList.replaceChildren();
      const iconTemplate = document.querySelector('[data-template-document-icon]');
      for (const key of keys) {
        const height = document.querySelector(`[data-flag-height="${key}"]`).value;
        const record = window.mvpChurchTemplates[key].find(t=>t.label===`${height} ft display · ${printing==='double'?'double':'single'}-sided`);
        if (record) {
          const link = document.createElement('a');
          link.className = 'selected-template-file';
          link.href = record.url;
          link.dataset.track = 'church_template_click';
          link.dataset.product = key;
          if (iconTemplate) link.append(iconTemplate.content.cloneNode(true));
          const copy = document.createElement('span');
          const name = document.createElement('strong');
          const details = document.createElement('small');
          const action = document.createElement('span');
          name.textContent = window.mvpChurchCatalog[key].name;
          details.textContent = record.label;
          action.className = 'selected-template-file__action';
          action.textContent = 'PDF ↓';
          copy.append(name, details);
          link.append(copy, action);
          templateList.append(link);
        }
      }
      document.querySelector('[data-selected-templates]').hidden = false;
    }
    try { sessionStorage.setItem(selectionKey, JSON.stringify({printing,base,heights:Object.fromEntries(keys.map(key=>[key,document.querySelector(`[data-flag-height="${key}"]`).value]))})); } catch {}
    if (announce) {
      comparison.querySelector('[data-configuration-status]').textContent = summaries.join('. ');
      window.mvpPrototypeEvents.push({ name: 'church_configuration_change', parameters: { source_page: document.body.dataset.page, printing, base }, timestamp: new Date().toISOString() });
    }
  };
  comparison.addEventListener('change', () => render(true));
  document.querySelectorAll('[data-flag-height]').forEach(select => select.addEventListener('change', () => render(true)));
  fit?.querySelectorAll('[name=rectangle-fit-size]').forEach(control => control.addEventListener('change', event => {
    if (!event.target.checked) return;
    if (visibilityDistance) visibilityDistance.value = defaultDistanceForSize[event.target.value];
    const select = document.querySelector('[data-flag-height="rectangle"]');
    select.value = event.target.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  const syncVisibilityToDistance = announce => {
    const select = document.querySelector('[data-flag-height="rectangle"]');
    const recommended = recommendForDistance(Number(visibilityDistance.value));
    if (select.value !== recommended) {
      select.value = recommended;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    renderFit(recommended, announce);
  };
  visibilityDistance?.addEventListener('input', () => syncVisibilityToDistance(false));
  visibilityDistance?.addEventListener('change', () => syncVisibilityToDistance(true));
  fit?.querySelector('[data-use-recommended]')?.addEventListener('click', () => {
    const select = document.querySelector('[data-flag-height="rectangle"]');
    select.value = recommendForDistance(Number(visibilityDistance.value));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
  render();
  fit?.querySelector('[data-fit-controls]')?.removeAttribute('hidden');
  document.querySelectorAll('[data-enhanced]').forEach(el => { el.hidden = false; });
})();
